import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SummaryChangeItem = (props) => {

    return (
        <tr>
            <td className="first">{props.question.questionText}</td>
            <td className="second">
                {props.prevQuestionResponse ? <React.Fragment>
                <strong>Rating:</strong> {props.prevQuestionResponse.responseText}
                <br />
                <strong>Comment:</strong> {props.prevQuestionResponse.commentText}
                </React.Fragment>
                : <React.Fragment /> }
        
            </td>
            <td className="third">
                {props.questionResponse ? <React.Fragment>
                <strong>Rating:</strong> {props.questionResponse.responseText}
                <br />
                <strong>Comment:</strong> {props.questionResponse.commentText}
                </React.Fragment>
                    : <React.Fragment />}
            </td>
            <td>
                {props.prevQuestionResponse && props.questionResponse ? <React.Fragment>{ props.questionResponse.responseText == props.prevQuestionResponse.responseText ? <strong>no change</strong> : <strong>change</strong> }</React.Fragment> : <strong>N/A</strong>}
            </td>
        </tr>
    )
}
export default SummaryChangeItem;